export const UPDATE_AUTH_MODAL = 'UPDATE_AUTH_MODAL';
export const updateAuthModal = modalStatus=> ({
  type: UPDATE_AUTH_MODAL,
  modalStatus: modalStatus
})
